import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TQuestion, IDeps } from './models';
import { Question as Component } from './question';

export { useQuestionContext } from './question';

export const Question = createWidget<IDeps, TQuestion>({})(Component);
